/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { css } from 'styled-components';

export interface TextProps {
  bold?: boolean;
  overflow?: 'ellipses' | 'wrap';
  color?: string;
}

export const overflowEllipsesStyle = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
